// extracted by mini-css-extract-plugin
export default {"container":"Qr_container__3AyE3","container__content":"Qr_container__content__cm4bX","container__buttons":"Qr_container__buttons__Se7Xw"};